import React, { useState } from 'react';

const Update = () => {
    return (
        <div className="container py-5 my-5">
            <h2>Co je nového?</h2>
            <ul class="list-group list-group-flush">
                <li class="list-group-item bg-transparent lead">
                    Přechod na nový framework
                </li>
                <li class="list-group-item bg-transparent lead">

                </li>
                <li class="list-group-item bg-transparent lead">
                    Pohodlnější darkmode
                </li>
            </ul>
        </div>
    )
        ;
};

export default Update;
